import React from 'react';
import DesignDashboard from "./dashboard/design-dashboard";

const Designs = ({}) => {
    return (
        <>
            <DesignDashboard/>
        </>
    )
}

export default Designs
